import { PerformerEntity } from "../../../entities/performer.entity";

export class MatrixDataInfoEntity extends PerformerEntity {

  constructor(id?: string, name?: string, type?: string) {
    super(id,name,type);
  }

  id: string; // 用于前端做唯一标识
  matrixDefId: string; // 用于存储字段id
  matrixDefName: string;
  conditionField1: string;
  conditionFieldText1: string;
  conditionField2: string;
  conditionFieldText2: string;
  conditionField3: string;
  conditionFieldText3: string;
  dataFieldAlias: string;
  condition: string;
  multivaluedCondition: string;
}
